import { selectEntregables } from './../states/entregables/selector';
import { Component, inject, OnDestroy, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { AddEditEntradaComponent } from './add-edit-entrada/add-edit-entrada.component';
import { EntradaService } from './entrada.service';
import { Observable, Subject, Subscription, firstValueFrom, forkJoin, map, of, takeUntil, timer, toArray } from 'rxjs';
import { Database, objectVal, ref, onValue, onChildChanged, onChildAdded, onChildRemoved, limitToLast, query, remove } from '@angular/fire/database';
import { iEntrada, iCatalogos, mEntrada, mCatalogos, defaultEntada, iAcuerdo, mAcuerdo, iComentarios, iFormasEnvio, iEntregables, iNotificaciones, mNotificaciones } from './entrada.interface';
import { AddEditArchivosComponent } from './add-edit-archivos/add-edit-archivos.component';
import { AddEditAsignacionResponsablesComponent } from './add-edit-asignacion-responsables/add-edit-asignacion-responsables.component';
import { AddEditEnvioAbComponent } from './add-edit-envio-ab/add-edit-envio-ab.component';
import { AddEditComentariosComponent } from './add-edit-comentarios/add-edit-comentarios.component';
import { AddEditRegistrosRelacionadosComponent } from './add-edit-registros-relacionados/add-edit-registros-relacionados.component';
import { Store, select } from '@ngrx/store';
import { AppState } from '../app.state';
import { selectCatalogos } from '../states/catalogos/selector';
import { cargaCatalogos } from '../states/catalogos/actions';
import { selectEntrada } from '../states/entrada/selector';
import { cargaEntrada, resetEntrada } from '../states/entrada/actions';
import { UsuarioService } from '../usuario/usuario.service';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AcuerdoMrbComponent } from '../acuerdo-mrb/acuerdo-mrb.component';
import { DespachoComponent } from '../despacho/despacho.component';
import { AcuerdoMrbService } from '../acuerdo-mrb/acuerdo-mrb.service';
import { LoadingService } from '../loading/loading.service';
import { AlertaService } from '../alerta/alerta.service';
import { selectAcuerdo } from '../states/acuerdo/selector';
import { cargaAcuerdo, cargaAcuerdoCampos, resetAcuerdo } from '../states/acuerdo/actions';
import { sortCatalogo, equals, getTimeConsole } from '../utils';
import { iUsuario } from '../usuario/usuario.interface';
import { selectUsuario } from '../states/usuario/selector';
import { selectComentarios } from '../states/comentarios/selector';
import { selectFormasEnvio } from '../states/formas-envio/selector';
import { AddEditEntregableComponent } from './add-edit-entregable/add-edit-entregable.component';
import { cargaEntregables, resetEntregables } from '../states/entregables/actions';
import { MatCardModule } from '@angular/material/card';
import { PreventDoubleClickDirective } from '../directives/prevent-double-click.directive';
import { SharedService } from '../shared.service';
import { LoggerService } from '../logger/logger.service';
import { toHTML, toDoc } from 'ngx-editor';
import moment from 'moment';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-entrada',
  standalone: true,
  imports: [MatToolbarModule,
            MatButtonModule,
            MatIconModule,
            MatTabsModule,
            ReactiveFormsModule, 
            MatInputModule, 
            MatFormFieldModule,
            FormsModule, 
            MatSelectModule,
            AcuerdoMrbComponent,
            DespachoComponent,
            AddEditEntradaComponent,
            AddEditArchivosComponent,
            AddEditAsignacionResponsablesComponent,
            AddEditEnvioAbComponent,
            AddEditComentariosComponent,
            AddEditRegistrosRelacionadosComponent,
            AddEditEntregableComponent,
            MatCardModule,
            CommonModule,
            PreventDoubleClickDirective],
  templateUrl: './entrada.component.html',
  styleUrl: './entrada.component.css'
})
export class EntradaComponent  {
  private active = inject(ActivatedRoute);
  private router = inject(Router);
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];
  private pathUrl = this.active.snapshot.url;
  private loadingService = inject(LoadingService);
  private alertaService = inject(AlertaService);
  private entradaService = inject(EntradaService);
  private usuarioService = inject(UsuarioService);
  private acuerdoMrbService = inject(AcuerdoMrbService);
  private sharedService = inject(SharedService);
  private loggerService = inject(LoggerService);
  private formBuilder:FormBuilder = inject(FormBuilder);
  private subscriptions = new Subscription();
  
  public readonly store: Store<AppState> = inject(Store);
  public readonly stateUsuario: any = this.store.pipe(select(selectUsuario));
  public readonly stateCatalogo: any = this.store.pipe(select(selectCatalogos));
  public readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  public readonly stateAcuerdo: any = this.store.pipe(select(selectAcuerdo));
  public readonly stateEntregables: any = this.store.pipe(select(selectEntregables))
  
  public sendToChilds: Subject<any> =  new Subject<any>();

  public modoEdicion: any = false;
  public oUsuario: iUsuario;
  public oEntrada: iEntrada;
  public oAcuerdo: iAcuerdo;
  public oCatalogos: iCatalogos;
  public oEntregables: iEntregables[];
  public oComentarios: iComentarios[] = [];
  public oFormasEnvio: iFormasEnvio[] = [];
  public oEntradaPadre: iEntrada;
  public oEntradaHistorico: any;
  public formAcuerdo!: FormGroup;
  public MatTabIndex:number = 0;
  public oNotificiaciones: iNotificaciones = structuredClone(mNotificaciones);
  public isloadingEntrada: boolean = false;
  public isloadingCatalogos: boolean = false;
  public isloadingAcuerdo: boolean = false;
  public isloadingUsuario: boolean = false;
  public isloadingMrB: boolean = false;
  public isloadingDespacho: boolean = false;
  public isComplete: boolean = false;
  public isExpired: boolean = false;
  public formValid: any = { entrada: false, asignacion_responsables: false, entregables: false, acuerdo: true };
  public ultimaModificacion: string = '';

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BOTONES
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  public lectura: boolean = false;
  public escritura: boolean = false;
  public bloqueado: boolean = false;
  public deshabilitado: boolean = false;
  public deshabilitado_Editar: boolean = false;
  public deshabilitado_BtnEditar: boolean = false;
  public deshabilitado_BtnGuardar: boolean = false;
  public headerEntrada = "Nueva Entrada";

  public timeout: any;
  public itemLock: any;
  public referenciaBloqueo: any;
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  
  constructor() {
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
    this.oUsuario = structuredClone(this.stateUsuario.state().usuario);
    this.oAcuerdo = structuredClone(this.stateAcuerdo.state().acuerdo);
    this.oCatalogos = structuredClone(this.stateCatalogo.state().catalogos);
    this.oEntregables = structuredClone(this.stateEntregables.state().entregables);
    this.oEntradaPadre = this.sharedService.getEntradaPadre();
    this.oEntradaHistorico = this.active.snapshot.queryParamMap.get('historicoEntrada');

    this.formAcuerdo = this.formBuilder.group({
      forma_envio: [0]
    });

    this.formAcuerdo.get('forma_envio')?.valueChanges.subscribe((value:any) => {
      this.businessRules('forma_envio', value);
    });
  }

  async ngOnInit() {
    this.loadingService.show();
    this.idEntrada = this.active.snapshot.params['id'];
    this.idTema = this.active.snapshot.params['tema'];

    //Cargamos Entrada if(!this.stateEntrada.state().entrada.isloading)
      this.cargaEntrada();

    //Cargamos Catalogos
    if(!this.stateCatalogo.state().catalogos.isloading)
      this.cargaCatalogos();

    //Cargamos Acuerdo
    if(!this.stateAcuerdo.state().acuerdo.isloading)
      this.cargaAcuerdo();

    //CARGAMOS DATOS DE ENTRADA, CATALOGOS Y ACUERDO
    this.subscriptions.add(
      this.store.select(selectComentarios).subscribe((oComentarios) => {
        this.oComentarios = structuredClone(oComentarios);
      })
    );

    this.subscriptions.add(
      this.store.select(selectFormasEnvio).subscribe((oFormasEnvio) => {
        this.oFormasEnvio = structuredClone(oFormasEnvio);
      })
    );

    this.subscriptions.add(
      this.store.select(selectEntregables).subscribe((oEntregables) => {
        this.oEntregables = structuredClone(oEntregables);
      })
    );

    this.subscriptions.add(
      this.store.select(selectEntrada).subscribe((entrada:iEntrada) => {
        this.oEntrada = structuredClone(entrada);
        if(this.isloadingEntrada == false && entrada.isloading == true) {
          this.isloadingEntrada = true;
          this.cargaTerminada();
        }
      })
    );

    this.subscriptions.add(
      this.store.select(selectAcuerdo).subscribe((acuerdo: any) => {
        this.oAcuerdo = structuredClone(acuerdo);
        if(this.isloadingAcuerdo == false && acuerdo.isloading == true) {
          this.isloadingAcuerdo = true;
          this.cargaTerminada();
        }
      })
    );
    
    this.subscriptions.add(
      this.store.select(selectUsuario).subscribe((oUsuario) => {
        this.oUsuario = structuredClone(oUsuario);
        if(this.isloadingUsuario == false && oUsuario.activo) {
          this.isloadingUsuario = true;
          this.cargaTerminada()
        }
      })
    );

    this.subscriptions.add(
      this.store.select(selectCatalogos).subscribe((catalogos:iCatalogos) => {
        if(this.isloadingCatalogos == false && catalogos.isloading == true) {
          this.isloadingCatalogos = true;
          this.cargaTerminada();
        }
      })
    );

    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      this.formAcuerdo.get('forma_envio')?.disable({emitEvent: false});
    }

    //oNotificaciones
    this.oNotificiaciones.comentarios.before = await firstValueFrom(this.entradaService.getComentario(this.idEntrada));
    this.oNotificiaciones.listaFormaEnvio.before = await firstValueFrom(this.entradaService.getFormasEnvio(this.idEntrada));
    this.oNotificiaciones.listaEntregables.before = await firstValueFrom(this.entradaService.obtenerEntregables(this.idEntrada));
  }

  ngOnDestroy() {
    this.store.dispatch(resetEntrada());
    this.store.dispatch(resetAcuerdo());
    this.store.dispatch(resetEntregables());
    this.subscriptions.unsubscribe();
    this.entradaService.setTaskUploadingEntrada();
  }

  async cargaEntrada () {
    let oEntrada: iEntrada = {...mEntrada};
    if(this.idEntrada !== 'add' && this.idTema !== 'new') {
      console.log("CARGA ENTRADA", getTimeConsole());
      const entrada = await firstValueFrom(this.entradaService.obtenerEntrada(this.idEntrada, this.idTema));
      console.log("CARGA ENTRADA TERMINADA", getTimeConsole());
      if(entrada == null) {
        this.alertaService.open("Alerta", "La entrada ya no existe");
        this.router.navigate(['/agenda']);
      } else {
        this.modoEdicion = { idEntrada: this.idEntrada, idTema: this.idTema };
        oEntrada = {...mEntrada, ...entrada, isloading: true};
        oEntrada.idEntrada = this.idEntrada;
        oEntrada.edicion = true;
        
        //OBTENEMOS SU ESTATUS PARA VALIDAR SI ES VENCIDO
        if(oEntrada.estatus_descripcion != "Terminado" && moment().isAfter(oEntrada.end)) {
          this.isExpired = true;
        } else if(oEntrada.estatus_descripcion == "Recibido") {
          oEntrada.estatus = "-Kc5BoA-Ov2F8k_X1Vy_";
          oEntrada.estatus_descripcion = "En proceso";
        }

        if(typeof(oEntrada.delegado) == "string") {
          oEntrada.delegado = oEntrada.delegado != ""?[oEntrada.delegado]:[];
          oEntrada.delegado_correo = oEntrada.delegado_descripcion;
          oEntrada.delegado_descripcion = oEntrada.delegado_descripcion;
        }
        
        if(typeof(oEntrada.remitente_enviado) == "object" && oEntrada.remitente_enviado.length == 1) {
          oEntrada.remitente_enviado = oEntrada.remitente_enviado.filter((item:any) => (item != '' && item != ' '));
        }
        
        if(typeof(oEntrada.remitente_enviado) == "string") {
          oEntrada.remitente_enviado = oEntrada.remitente_enviado != ""?[oEntrada.remitente_enviado]:[];
          oEntrada.remitente_enviado_correo = oEntrada.remitente_enviado_descripcion;
          oEntrada.remitente_enviado_descripcion = oEntrada.remitente_enviado_descripcion;
        }

        //FIX PARA REMITENTES Y DELEGADOS
        if(oEntrada.vip && oEntrada.remitente_enviado.length > 0 && oEntrada.delegado.length > 0) {
          oEntrada.delegado = [];
          oEntrada.delegado_correo = '';
          oEntrada.delegado_descripcion = '';
        }

        //FIX PARA ACTIVAR ENTREGABLES
        const entregables:any = await firstValueFrom(this.entradaService.obtenerEntregables(this.idEntrada));
        if(entregables.length > 0 && oEntrada.banEntregables == false) {
          oEntrada.banEntregables = true;
        }

        //FIX PARA VALIDAR ENTREGABLES
        if(entregables.length > 0 && oEntrada.analista == '' && oEntrada.supervisor == '' && oEntrada.coordinador == '') {
          const { analista, analista_descripcion, supervisor, supervisor_descripcion, coordinador, coordinador_descripcion } = entregables[0];
          oEntrada.analista = analista;
          oEntrada.analista_descripcion = analista_descripcion;
          oEntrada.supervisor = supervisor;
          oEntrada.supervisor_descripcion = supervisor_descripcion;
          oEntrada.coordinador = coordinador;
          oEntrada.coordinador_descripcion = coordinador_descripcion;
          
          this.alertaService.open("Error", "Detectamos un error en la asignación de los responsables. Por favor, guarda la entrada nuevamente.");
        }
        
        //oNotificaciones
        this.oNotificiaciones.entrada.before = oEntrada;
      }
    } else {
      if(this.oEntradaPadre && this.pathUrl.filter((item:any) => item.path == 'child').length == 1) {
        console.log("CARGA PADRE", getTimeConsole());
        oEntrada = this.cargarEntradaPadre(oEntrada);
        console.log("CARGA PADRE TERMINADA", getTimeConsole());
      }
      
      if(this.oEntradaHistorico) {
        console.log("CARGA HISTORICO", getTimeConsole());
        oEntrada = await this.cargarEntradaHistorico(oEntrada);
        console.log("CARGA HISTORICO TERMINADA", getTimeConsole());
      }

      oEntrada.isloading = true;
    }

    this.store.dispatch(cargaEntrada({ oEntrada }));
  }

  async cargaCatalogos () {
    console.log("CARGA CATALOGOS", getTimeConsole());
    this.subscriptions.add(
      forkJoin({
        catTema:          firstValueFrom(this.entradaService.getTemas()),
        catTipo:          firstValueFrom(this.entradaService.getCatalogo('tipo')),
        catModoEntrada:   firstValueFrom(this.entradaService.getCatalogo('modo_entrada')),
        catPrioridad:     firstValueFrom(this.entradaService.getCatalogo('prioridad')),
        catEmpresa:       firstValueFrom(this.entradaService.getCatalogo('empresa')),
        catRemitente:     firstValueFrom(this.entradaService.getCatalogo('remitente')),
        catEnvioAB:       firstValueFrom(this.entradaService.getCatalogo('forma_envio')),
        catFormaEnvio:    firstValueFrom(this.acuerdoMrbService.getCatalogo(this.acuerdoMrbService.cats.TIPO_FORMA_ENVIO)),
        catUsuarios:      firstValueFrom(this.usuarioService.getUsuarios()),
        catEntregable:    firstValueFrom(this.entradaService.getCatalogo('entregable')),
      }).subscribe({
        next: (oCatalogos:iCatalogos) => {
          console.log("CARGA CATALOGOS TERMINADA", getTimeConsole());
          oCatalogos.catEmpresa  = sortCatalogo(oCatalogos.catEmpresa, 'descripcion');
          oCatalogos.catUsuarios = sortCatalogo(oCatalogos.catUsuarios, 'nombre');

          //DUPLICAMOS USUARIO SUPERVISOR EN ESPECIFICO
          let usuarioClone = oCatalogos.catUsuarios.filter(item => (item.id == environment.user_supervisor && item.rol == 2));
          if(usuarioClone.length == 1) {
            let usuarioCoordinador = structuredClone(usuarioClone[0]);
            usuarioCoordinador.rol = 3;
            oCatalogos.catUsuarios.push(usuarioCoordinador);
          }

          oCatalogos.isloading = true;
          this.oCatalogos = oCatalogos;
          this.store.dispatch(cargaCatalogos({ oCatalogos }));
        },
        error: (msg) => console.error('Cargar Catalogos : ', msg)
      })
    );
  }

  async cargaAcuerdo () {
    let oAcuerdo = {...mAcuerdo, isloading: true};
    
    if(this.idEntrada != "add") {
      console.log("CARGA ACUERDO", getTimeConsole());
      const result: any = await firstValueFrom(this.entradaService.consultarAcuerdoPorEntrada(this.idEntrada));
      console.log("CARGA ACUERDO TERMINADA", getTimeConsole());

      if(!result.error) {
        oAcuerdo = {...mAcuerdo, ...result.acuerdo, isloading: true};
        this.formAcuerdo.get('forma_envio')?.setValue(oAcuerdo.id_tipo_forma, {emitEvent: false});
        this.isloadingMrB = oAcuerdo.id_tipo_forma == 1 ? true : false;
        this.isloadingDespacho = oAcuerdo.id_tipo_forma == 2 ? true : false;
      }
    }
    
    this.store.dispatch(cargaAcuerdo({ oAcuerdo }));
  }

  async cargaEntregables() {
    let result:any = [];
    if (this.idEntrada != "add") {
      result = await firstValueFrom(this.entradaService.obtenerEntregables(this.idEntrada));
    }
    
    let oEntregables = await Promise.all(result.map(async (item: iEntregables) => {
      if (this.oUsuario.uid == item.analista && item.url == undefined && item.tipo != "adjuntar") {
        item.nuevo = true;
        item.used = false;
      } else if (this.oUsuario.uid != item.analista && item.url == undefined && item.tipo != "adjuntar") {
        item.url = null;
        item.title = null;
        item.idGas = null;
        item.nuevo = true;
      } else if (item.url == undefined && item.tipo == "adjuntar") {
        item.url = null;
        item.title = null;
        item.idGas = null;
      }

      if (item.archivos != undefined && item.id) {
        item.files = structuredClone(item.archivos);
        let oArchivos = await this.entradaService.obtenerArchivoEntregable(item.id, item.archivos);
        item.archivos = oArchivos;
      } else {
        item.archivos = [];
        item.files = [];
      }

      return item;
    }));

    this.store.dispatch(cargaEntregables({ oEntregables: oEntregables }));
  }
  
  async cargaTerminada () {
    if(this.isloadingEntrada && this.isloadingCatalogos && this.isloadingAcuerdo && this.isloadingUsuario) {
      console.log("cargaTerminada");
      this.loadingService.hide();
      //this.formAcuerdo.get('forma_envio')?.setValue(this.oAcuerdo.id_tipo_forma);
      this.inicializa();
    }
  }

  businessRules(type: string, value: any) {
    if(type == 'forma_envio' && value != 0) {

      if(this.oAcuerdo.id_tipo_forma != 0 && this.oAcuerdo.id_tipo_forma != value && this.oAcuerdo.numeroEntradasTema == 1) {
        this.alertaService.open("Importante", "El tema debe contener al menos una entrada. Seleccione la acción ‘Quitar tema’ desde la tabla de despacho, si desea desasociar la entrada y eliminar el tema.");
        this.formAcuerdo.get('forma_envio')?.setValue(this.oAcuerdo.id_tipo_forma, { emitEvent: false });
        return;
      }

      if(this.oEntrada.empresa == '' && value == 2) {
        this.alertaService.open("Error", "Para continuar, es necesario seleccionar una empresa");

        if(this.isloadingMrB)
          this.formAcuerdo.get('forma_envio')?.setValue(1, { emitEvent: false });
        else 
          this.formAcuerdo.get('forma_envio')?.setValue('', { emitEvent: false });

        return;
      }

      if(this.oAcuerdo.id_tipo_forma != value)
        this.store.dispatch(cargaAcuerdoCampos({ oData: { id_tipo_forma: value} }));

      this.isloadingMrB = value == 1 ? true : false;
      this.isloadingDespacho = value == 2 ? true : false;
    }
  }

  acuerdosCargados () {
    this.sendToChilds.next({accion: 'disabled', deshabilitado: this.deshabilitado});
  }

  listenToChilds (oData:any) {
    if(oData.changeTab) {
      this.MatTabIndex = oData.changeTab;
    }

    if(oData.accion) {
      if(oData.accion == 'GUARDADO AUTOMATICO') {
        console.log("ENTRA A GUARDAR AUTOMATICO LISTENER");
        let entradaValida = (this.formValid.entrada &&  this.formValid.asignacion_responsables && this.formValid.entregables);
        
        //FIX PARA VALIDAR ENTREGABLES
        if(this.oEntrada.analista == '' && this.oEntrada.supervisor == '' && this.oEntrada.coordinador == '') {
          this.alertaService.open("Error", "Se han perdido datos de los responsables antes en guardado automatico COD-003.");
          this.loadingService.hide();
          return;
        }

        if(entradaValida) {
            this.guardar(true);
        } else {
          this.alertaService.open("Error", "Valide que todos los documentos han sido generados y los campos obligatorios se encuentren completos");
          this.loadingService.hide();
        }
      }

      if(oData.accion == 'ACUERDO CARGADO') {
        this.acuerdosCargados();
      }
    }

    if(oData.formEntrada)
      this.formValid.entrada = oData.formEntrada == 'VALID'?true:false;
    
    if(oData.formAsigResp)
      this.formValid.asignacion_responsables = oData.formAsigResp == 'VALID'?true:false;

    if(oData.formEntregables)
      this.formValid.entregables = oData.formEntregables == 'VALID'?true:false;

    if(oData.formAcuerdo)
      this.formValid.acuerdo = (oData.formAcuerdo == 'VALID' || oData.formAcuerdo == 'DISABLED')?true:false;
  }

  loading () {
    this.loadingService.show();
  }

  async guardar (automatico: boolean = false) {
    console.log("ENTRA A FUNCION GUARDAR");

    this.loadingService.show();
    
    if(this.formValid.entrada) {
      let oEntrada: any     = structuredClone(this.oEntrada); // {...this.oEntrada};
      let oComentarios: any = [...this.oComentarios.map(item => { item.tema = this.oEntrada.tema; if(item.id) item.$id = item.id; return item})];
      let oFormasEnvio: any = [...this.oFormasEnvio.map(item => { if(item.id) item.$id = item.id; return item})];
      let oArchivos: any    = [...this.oEntrada.archivos];
      let oAcuerdo: any     = {...this.oAcuerdo};
      let oEntregables: any = [...this.oEntregables];
      let oPadre: any       = false;
      
      oEntrada.fechaInicio =  moment(this.oEntrada.fechaInicio)?.format('YYYY-MM-DD[T06:00:00.000Z]')
      oEntrada.fechaFin =     moment(this.oEntrada.fechaFin)?.format('YYYY-MM-DD[T23:00:00.000Z]')
      oEntrada.start =        moment(this.oEntrada.fechaInicio)?.format('YYYY-MM-DD[T00:00:00.00]')
      oEntrada.end =          moment(this.oEntrada.fechaFin)?.format('YYYY-MM-DD[T23:00:00.00]')

      oEntrada.lastMod =      new Date().getTime();
      oEntrada.descripcion =  this.oEntrada.descripcion; 
      oEntrada.descripcion_html = this.oEntrada.descripcion_html;
      oEntrada.estatus_descripcion = this.oEntrada.estatus_descripcion;
      
      oEntrada.uidLastUpdate =  this.oUsuario.uid;
      oEntrada.tsLastUpdate =   new Date().getTime();
      oEntrada.nameLastUpdate = this.oUsuario.nombre;
      oEntrada.tipoCorreo =     parseInt(`${this.oEntrada.tipoCorreo}`);

      if (this.idEntrada == "add") {
        oEntrada.uid = this.oUsuario.uid;
        oEntrada.tsCreation = new Date().getTime();
        oEntrada.estatus = "-Kc5BoA-Ov2F8k_X1Vy_";
        oEntrada.estatus_descripcion = "En proceso";
      } else {
        if(oEntrada.estatus_descripcion.toUpperCase().includes("TERMINADO") && (!moment().isAfter(oEntrada.end) || oEntregables.filter((item:any) => item.estatus == 1).length > 0)) {
            oEntrada.estatus = "-Kc5BoA-Ov2F8k_X1Vy_";
            oEntrada.estatus_descripcion = "En proceso";
        }  
      }

      //ELIMINAMOS DATOS DE CONTROL
      delete oEntrada.desabilitado;
      delete oEntrada.edicion;
      delete oEntrada.idEntrada;
      delete oEntrada.isloading;

      //oNOTIFICACIONES
      this.oNotificiaciones.entrada.after = {...oEntrada};
      this.oNotificiaciones.comentarios.after = [...oComentarios];
      this.oNotificiaciones.listaFormaEnvio.after = [...oFormasEnvio];
      this.oNotificiaciones.listaEntregables.after = [...oEntregables];

      //oACUERDOS
      if(this.formAcuerdo.get('forma_envio')?.value !== 0 && oAcuerdo.id_tema && oAcuerdo.id_tipo_forma) {
        oEntrada.id_tema = oAcuerdo.id_tema;
        oEntrada.id_tipo_forma = oAcuerdo.id_tipo_forma;
      }

      //oPADRE
      if(oEntrada.idPadre && oEntrada.idPadreTema) {
        try {
          oPadre = await firstValueFrom(this.entradaService.obtenerEntrada(oEntrada.idPadre, oEntrada.idPadreTema));  
        } catch (error) {
          this.loadingService.hide();
          this.alertaService.open("Error", "Lo sentimos, no es posible editar esta entrada ya que cuenta con registros relacionados en los cuales usted no tiene acceso.");
          return;
        }
      }

      //oMIGRADO
      if(this.oEntrada.hasOwnProperty('migrado') && this.oEntrada.migrado) {
        delete oEntrada.migrado;
      }

      if(oEntrada.relacionados) {
        console.log(oEntrada.relacionados, this.oEntradaPadre);
        //delete oEntrada.relacionados;
      }

      //FIX PARA VALIDAR ENTREGABLES
      if(oEntregables.length > 0 && oEntrada.analista == '' && oEntrada.supervisor == '' && oEntrada.coordinador == '') {
        this.alertaService.open("Error", "Se han perdido datos de los responsables antes de guarda la entrada COD-001.");
        return;
      }

      this.entradaService.guardar(this.modoEdicion, oEntrada, oComentarios, oFormasEnvio, oArchivos, oAcuerdo, oEntregables, oPadre, this.oUsuario, this.oCatalogos).then(async (result:any) => {
        this.loadingService.show();
        console.log(result);
        const idKey = result[0];
        let msgError: any = false;

        for(let i in result) {
          if(!(typeof result[i] == 'string')) {
            msgError = (result[i].message)?result[i].message: result[i];
            console.warn(msgError);
            this.loggerService.addLog(msgError);
            this.alertaService.open("Error 030", msgError);
          }
        }

        //oNOTIFICACIONES
        if(this.fnNotificacion()) {
          this.oNotificiaciones.entrada.id = idKey;
          await this.entradaService.enviaNotificacion(this.oNotificiaciones).then(result => {
            console.log('Notificacion Enviada');
          }).catch(error => {
            this.loggerService.addLog(error);
          });
        }

        //oDESPACHO
        if(this.formAcuerdo.get('forma_envio')?.value !== 0 && oAcuerdo.id_tema && oAcuerdo.id_tipo_forma) {
          this.sendToChilds.next({accion: 'notificacion', tipo: 'despacho'});
        }

        //oACUERDO
        await this.entradaService.guardarAcuerdo(idKey, oAcuerdo).then(result => {
          console.log(result);
        }).catch(error => {
          this.loggerService.addLog(error);
        });

        console.log(oEntrada.relacionados);
        //VALIDAMOS SIN ES UNA ENTRADA EXISTENTE (MODO EDICION)
        if(this.modoEdicion) {
          //SI LA ENTRADA SE CAMBIA DE TEMA BORRAMOS EL NODO ANTERIOR
          if(this.modoEdicion.idTema != oEntrada.tema) {
              await this.entradaService.borrarEntrada(this.modoEdicion.idTema, this.modoEdicion.idEntrada);
              
              //SI LA ENTRADA SE CAMBIA DE TEMA ACTUALIZAMOS LOS HIJOS
              if(oEntrada.relacionados && oEntrada.relacionados.hijos.length > 0) {
                this.entradaService.actualizamosTemaHijos(oEntrada.tema, this.modoEdicion.idEntrada);
              }
          }
        }

        if(!msgError){
          this.alertaService.open("Éxito", "Se ha guardado tu entrada!!!");
        } else {
          this.alertaService.open("Error", "Lo sentimos, la entrada pudo no ser guardar en su totalidad, favor de verificar e intentar nuevamente");
        }

        this.loadingService.hide();

        if(automatico && this.modoEdicion == false) {
          this.showEntrada(idKey, oEntrada.tema);
        } else {
          this.showAgenda();
        }
      }).catch((error: any) => {
        this.alertaService.open("Error", "Lo sentimos, la entrada pudo no ser guardar en su totalidad, favor de verificar e intentar nuevamente");
        this.loadingService.hide();
        this.loggerService.addLog(error);
        this.showAgenda();
      });
    } else {
      this.loadingService.hide();
      this.alertaService.open("Error", "Faltan algunos campos que acompletar.");
    }
  }

  fnNotificacion () {
    if(this.oEntrada.edicion) {
        var entrada_before = this.oNotificiaciones.entrada.before;
        var comentarios_before  = this.oNotificiaciones.comentarios.before
        var listaFormaEnvio_before  = this.oNotificiaciones.listaFormaEnvio.before;

        var fechaInicio =       (this.formatDateToString(entrada_before.fechaInicio) == this.formatDateToString(this.oEntrada.fechaInicio));
        var fechaFin =          (this.formatDateToString(entrada_before.fechaFin)    == this.formatDateToString(this.oEntrada.fechaFin));

        var asunto =            this.equalPrimitives(entrada_before.asunto,             this.oEntrada.asunto);
        var descripcion =       this.equalPrimitives(entrada_before.descripcion_html,   this.oEntrada.descripcion_html);
        var remitente =         this.equalPrimitives(entrada_before.remitente,          this.oEntrada.remitente);
        var delegado =          this.equalPrimitives(entrada_before.delegado,           this.oEntrada.delegado);
        var empresa =           this.equalPrimitives(entrada_before.empresa,            this.oEntrada.empresa);
        var copia =             this.equalPrimitives(entrada_before.copia,              this.oEntrada.copia);
        var estatus =           this.equalPrimitives(entrada_before.estatus,            this.oEntrada.estatus);
        var archivos =          this.equalPrimitives(entrada_before.archivos,           this.oEntrada.archivos);
        var seguimiento =       this.equalPrimitives(entrada_before.seguimiento,        this.oEntrada.seguimiento);

        var comentario =        this.equalPrimitives(this.cleanIds(comentarios_before),     this.cleanIds(this.oComentarios));
        var formaEnvio =        this.equalPrimitives(this.cleanIds(listaFormaEnvio_before), this.cleanIds(this.oFormasEnvio));
        
        if(!asunto || !descripcion || !remitente || !delegado || !empresa || !copia || !fechaInicio || !fechaFin || !estatus || !archivos || !comentario || !formaEnvio || !seguimiento) {
          console.log('asunto: ',         asunto);
          console.log('descripcion: ',    descripcion);
          console.log('remitente: ',      remitente);
          console.log('delegado: ',       delegado);
          console.log('empresa: ',        empresa);
          console.log('copia: ',          copia);
          console.log('fechaInicio: ',    fechaInicio);
          console.log('fechaFin: ',       fechaFin);
          console.log('estatus: ',        estatus);
          console.log('archivos: ',       archivos);
          console.log('comentario: ',     comentario);
          console.log('formaEnvio: ',     formaEnvio);
          console.log('seguimiento : ',   seguimiento);
          debugger;

          return true;
        }

        return false;
    }

    return true;
  }

  formatDateToString (fecha: any) {
    if(typeof fecha == 'object') {
      return moment(fecha).format('YYYY-MM-DD');
    }
    return fecha.substring(0,10);
  }

  equalPrimitives<T>(a: T, b: T): boolean {
    if(typeof a == 'string' && typeof b == 'string') {
      return (a == b)
    }

    return equals(a, b);
  }

  cleanIds(oData: any) {
    let data = structuredClone(oData).map((item: any) => {
      if(item.$id) {
        item.id = item.$id;
        delete item.$id;
      }
     
      return item;
    });

    return data;
    //return sortCatalogo(data, 'id');
  }

  showAgenda () {
    remove(this.referenciaBloqueo);
    this.router.navigate(['/agenda']);
  }

  showEntrada (id:string, tema:string) {
    remove(this.referenciaBloqueo);
    this.router.navigateByUrl('/agenda', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/entrada/'+tema+'/'+id]);
    });
  }

  obtenerPorcentaje (uploadTask: any) {
    uploadTask.on('state_changed', (snapshot: any) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
      return progress;
    }, (error: any) => {
      console.log(error);
    }, 
    () => {
      console.log('File available');
    });
  }

  async inicializa () {
    this.deshabilitado_Editar = this.fnInhabilitaCampos();
    this.lectura = this.getPermisoLeer();
    this.escritura = this.getPermisoEscribir();

    if(this.idEntrada != 'add') {
      this.deshabilitado = true;
      this.headerEntrada = 'Edición de Entrada';
    }

    //Obtenemos el usuario y hora de ultima modificacion
    if(this.oEntrada.tsLastUpdate && this.oEntrada.nameLastUpdate) {
      this.ultimaModificacion = `Última actualización 
                                ${moment(this.oEntrada.tsLastUpdate).format("DD/MM/YYYY")}  a las 
                                ${moment(this.oEntrada.tsLastUpdate).format("hh:mm a")} por 
                                ${this.oEntrada.nameLastUpdate}`;
    }

    this.referenciaBloqueo = this.entradaService.obtenerReferenciaLock(this.idEntrada);
    this.itemLock = await firstValueFrom(this.entradaService.obtenerEntradaLock(this.idEntrada));

    if(this.itemLock && this.itemLock.hasOwnProperty('id')) {
      var milisegundos = new Date().getTime() - this.itemLock.timestamp;
      if(milisegundos >= 300000) {
        remove(this.referenciaBloqueo);
      } else {
        if(this.itemLock.id == this.oUsuario.uid) {
          this.bloqueado = false;
          this.deshabilitado = false;
          if(this.oAcuerdo.id_edo_tema != 3)
            this.formAcuerdo.get('forma_envio')?.enable({emitEvent: false});
          this.sendToChilds.next({accion: 'disabled', deshabilitado: this.deshabilitado});
        } else {
          this.bloqueado = true;
          this.deshabilitado = true;
          this.formAcuerdo.get('forma_envio')?.disable({emitEvent: false});
          this.sendToChilds.next({accion: 'disabled', deshabilitado: this.deshabilitado});
          
          //this.bloqueadoId = this.itemLock.lock.id;
          //this.bloqueadoUsuario = this.itemLock.lock.nombre;
          //this.bloqueadoHora = ec.getDateFormat(this.itemLock.lock.timestamp);
          this.fnTimerBloqueo(300000 - milisegundos);
        }
      }
    }

    if(this.oEntrada.hasOwnProperty('migrado') && this.oEntrada.migrado) {
      this.alertaService.open("Estatus de Migración", "Para recibir notificaciones de esta entrada, es necesario realizar el llenado de los campos y guardar.");
    }

    onChildAdded(this.referenciaBloqueo, (data: any) => {
      this.fnAddBloqueo(data.key, data.val());
    });
    
    onChildChanged(this.referenciaBloqueo, (data: any) => {
      this.fnAddBloqueo(data.key, data.val());
    });
    
    onChildRemoved(this.referenciaBloqueo, (data: any) => {
      this.fnRemBloqueo(data.key, data.val());
    });

  }

  editar () {
    if(this.deshabilitado_Editar === true) {
      this.alertaService.open('Alerta', 'No cuenta con los permisos correspondientes para editar esta entrada.');
      this.deshabilitado_BtnEditar = true;
    } else {
      this.deshabilitado = false;
      if(this.oAcuerdo.id_edo_tema != 3)
        this.formAcuerdo.get('forma_envio')?.enable();
      this.entradaService.bloqueoEntrada(this.idEntrada, this.idTema, this.oUsuario);
    }    
  }
  
  crearEntradaHijo () {
    this.oEntrada.id = this.idEntrada;
    this.sharedService.setEntradaPadre(this.oEntrada);
    this.router.navigate(['/entrada/new/add/child']);
  }

  fnInhabilitaCampos () {
    let deshabilitar_padre = false;
    if (this.oEntrada.idPadre && this.oEntrada.idPadreTema) {
      if(this.oUsuario.temas[this.oEntrada.idPadreTema] == undefined || this.oUsuario.temas[this.oEntrada.idPadreTema].permiso == 1) {
        return deshabilitar_padre = true;
      }
    }
    return deshabilitar_padre;
  }

  getPermisoEscribir () {
    let escritura = false;
    
    if(this.idTema == 'new' && Object.keys(this.oUsuario.temas).length > 0) {
      escritura = true;
    }
    
    if(this.oUsuario.temas[this.idTema] && this.oUsuario.temas[this.idTema].permiso >= 2) {
      escritura = true;
    }

    return escritura; 
  }

  getPermisoLeer () {
    let lectura = false;
    if(this.oUsuario.temas.hasOwnProperty(this.idTema) && (this.oUsuario.temas[this.idTema].permiso == 1 || this.oUsuario.temas[this.idTema].permiso == 3)) {
      lectura = true;
    }
    return lectura;
  }

  fnAddBloqueo (key: any, data: any) {
    if(key == 'lock') {
      this.itemLock = data;
      if(this.itemLock.id == this.oUsuario.uid) {
          this.deshabilitado = false;
          this.bloqueado = false;
      } else {
          this.deshabilitado = true;
          this.bloqueado = true;
          this.fnTimerBloqueo(300000);
      }
    }

    this.sendToChilds.next({accion: 'disabled', deshabilitado: this.deshabilitado});
  }

  fnRemBloqueo (key: any, data: any) {
    if(key == 'lock') {
      clearTimeout(this.timeout);
      this.bloqueado = false;
      this.deshabilitado = true;
      this.itemLock = null;
    }
    this.sendToChilds.next({accion: 'disabled', deshabilitado: this.deshabilitado});
  }

  fnTimerBloqueo (milisegundos: number) {
    this.timeout = setTimeout(()=> {
      remove(this.referenciaBloqueo);
    }, milisegundos);
  }

  getDateFormat (timestamp: string) {
    var date = moment(timestamp).format('HH:mm:ss');
    return date;
  }

  cargarEntradaPadre (oEntrada: iEntrada) {
    let itemPadre = structuredClone(this.oEntradaPadre);
    this.sharedService.setEntradaPadre(false);
    let idRemitente: string = '';

    if(itemPadre.remitente_enviado == undefined) {
      itemPadre.remitente_enviado = [];
      itemPadre.remitente_enviado_descripcion = "";
      itemPadre.remitente_enviado_correo = "";
    }

    if(itemPadre.delegado == undefined) {
      itemPadre.delegado = [];
      itemPadre.delegado_descripcion = "";
      itemPadre.delegado_correo = "";
    }

    if(itemPadre.copia == undefined) {
      itemPadre.copia = [];
      itemPadre.copia_descripcion = "";
      itemPadre.copia_correo = "";
    }

    //HEREDA REMITENTE Y ENVIADOS A, EN CASO QUE SEA PADRE TIPO ENTRADA 1
    if(itemPadre.tipoCorreo == 1) {
      oEntrada.remitente_enviado =              itemPadre.remitente_enviado;
      oEntrada.remitente_enviado_correo =       itemPadre.remitente_enviado_correo;
      oEntrada.remitente_enviado_descripcion =  itemPadre.remitente_enviado_descripcion;

      oEntrada.delegado =                       itemPadre.delegado;
      oEntrada.delegado_correo =                itemPadre.delegado_correo;
      oEntrada.delegado_descripcion =           itemPadre.delegado_descripcion;
      
      oEntrada.copia =                          itemPadre.copia;
      oEntrada.copia_correo =                   itemPadre.copia_correo;
      oEntrada.copia_descripcion =              itemPadre.copia_descripcion;
      
      //PASAMOS AL REMITENTE A UN ENVIDADO O DELEGADO
      if(itemPadre.vip) {
        oEntrada.remitente_enviado =              [itemPadre.remitente];
        oEntrada.remitente_enviado_correo =       itemPadre.remitente_correo;
        oEntrada.remitente_enviado_descripcion =  itemPadre.remitente_descripcion;
      } else {
        oEntrada.delegado =                       [itemPadre.remitente];
        oEntrada.delegado_correo =                itemPadre.remitente_correo;
        oEntrada.delegado_descripcion =           itemPadre.remitente_descripcion;
      }

      idRemitente = itemPadre.delegado.length > 0 ? itemPadre.delegado[0] : itemPadre.remitente_enviado[0];
    }
    
    //HEREDA REMITENTE Y ENVIADOS A, EN CASO QUE SEA PADRE TIPO SALIDA
    if(itemPadre.tipoCorreo == 2) {
      oEntrada.copia =              itemPadre.copia;
      oEntrada.copia_descripcion =  itemPadre.copia_descripcion;
      oEntrada.copia_correo =       itemPadre.copia_correo;

      oEntrada.delegado =             [itemPadre.remitente];
      oEntrada.delegado_correo =      itemPadre.remitente_correo;
      oEntrada.delegado_descripcion = itemPadre.remitente_descripcion;

      idRemitente = (itemPadre.remitente_enviado.length > 0)? itemPadre.remitente_enviado[0]: '';
    }

    //SELECCIONAMOS AL REMITENTE
    const oRemitente: any = this.oCatalogos.catRemitente.filter((item:any) =>  item.id == idRemitente && item.activo);
    if(oRemitente.length > 0) {
      const remitente = oRemitente[0];
      oEntrada.remitente = remitente.id;
      oEntrada.remitente_correo = remitente.mail;
      oEntrada.remitente_descripcion = `${remitente.nombre} ${remitente.apellido} | ${remitente.mail}`;
    }

    oEntrada.asunto                = itemPadre.asunto;
    oEntrada.tema                  = itemPadre.tema;
    oEntrada.tema_descripcion      = itemPadre.tema_descripcion;
    oEntrada.tipo                  = itemPadre.tipo;
    oEntrada.tipo_descripcion      = itemPadre.tipo_descripcion;
    oEntrada.prioridad             = itemPadre.prioridad;
    oEntrada.prioridad_descripcion = itemPadre.prioridad_descripcion;
    oEntrada.empresa               = itemPadre.empresa;
    oEntrada.empresa_descripcion   = itemPadre.empresa_descripcion;

    //CREAMOS LA RELACION AL PADRE
    oEntrada.idPadre               = itemPadre.id!;
    oEntrada.idPadreTema           = itemPadre.tema;

    //VALIDAMOS QUE EL MODO DE ENTRADA NO SEA SOBRE CERRADO
    if(!itemPadre.modo_entrada_descripcion.toUpperCase().includes("SOBRE")) {
      oEntrada.modo_entrada             = itemPadre.modo_entrada;
      oEntrada.modo_entrada_descripcion = itemPadre.modo_entrada_descripcion;
    }

    //VALIDAMOS SI TIENE RELACIONADOS PADRE Y HERMANOS
    oEntrada.relacionados = { 
      padre: [{
        asunto:                 itemPadre.asunto,
        status:                 itemPadre.estatus_descripcion,
        remitente_descripcion:  itemPadre.remitente_descripcion,
        delegado_descripcion:   itemPadre.delegado_descripcion,
        copia_descripcion:      itemPadre.copia_descripcion,
        descripcion:            itemPadre.descripcion
      }],
      hijos: [],
      hermanos: (itemPadre.relacionados && itemPadre.relacionados.hijos)? itemPadre.relacionados.hijos : []
    };

    return oEntrada;    
  }

  async cargarEntradaHistorico (oEntrada: iEntrada) {
    const params = this.oEntradaHistorico.split('/');

    if(params.length == 2) {
      const entrada = await firstValueFrom(this.entradaService.obtenerHistorico(params[1], params[0]));
      oEntrada = {...mEntrada, ...entrada, isloading: true};
      
      if(entrada == null) {
        this.alertaService.open("Alerta", "La entrada ya no existe");
        this.router.navigate(['/agenda']);
      }

      oEntrada.fechaInicio = entrada.fechaEnt;
      oEntrada.descripcion_html = entrada.descripcion;
      oEntrada.estatus = "-Kc5BoA-Ov2F8k_X1Vy_";
      oEntrada.estatus_descripcion = "En proceso";

      if(this.oCatalogos.catModoEntrada.filter((item:any) => { return item.id == oEntrada.modo_entrada }).length == 0) {
        oEntrada.modo_entrada = '';
        oEntrada.modo_entrada_descripcion = ''; 
      }

    }

    return oEntrada;
  }
}